var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "simple-form" }, [
      _c(
        "div",
        {
          staticClass: "form-group col-6 fl",
          staticStyle: { "padding-left": "0px" }
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value" },
            [
              _c(
                "el-checkbox",
                {
                  on: { change: _vm.autoApplyChange },
                  model: {
                    value: _vm.autoApply,
                    callback: function($$v) {
                      _vm.autoApply = $$v
                    },
                    expression: "autoApply"
                  }
                },
                [_vm._v("自动申请")]
              )
            ],
            1
          )
        ]
      ),
      _vm._v(" "),
      _vm.autoApply
        ? _c("div", { staticClass: "form-group col-6 fl" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-value" },
              [
                _c(
                  "el-checkbox",
                  {
                    model: {
                      value: _vm.autoAudit,
                      callback: function($$v) {
                        _vm.autoAudit = $$v
                      },
                      expression: "autoAudit"
                    }
                  },
                  [_vm._v("自动审核")]
                )
              ],
              1
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _c("div", { staticStyle: { width: "100%", "overflow-y": "auto" } }, [
      _c("span", { staticClass: "font-orange" }, [
        _vm._v(
          "【共" +
            _vm._s(_vm.servicerCount()) +
            "个配件提供商，" +
            _vm._s((_vm.accList || []).length) +
            "个配件】"
        )
      ]),
      _vm._v(" "),
      _c("table", { staticClass: "custom-tbl" }, [
        _vm._m(2),
        _vm._v(" "),
        _c(
          "tbody",
          { staticClass: "body" },
          [
            _vm._l(_vm.accList, function(accInfo) {
              return _c("tr", { staticClass: "row" }, [
                _c("td", { staticStyle: { "text-align": "left" } }, [
                  _vm._v(_vm._s(accInfo.srcServicerName))
                ]),
                _vm._v(" "),
                _c("td", { staticStyle: { "text-align": "left" } }, [
                  _vm._v(_vm._s(accInfo.srcWarehouseName))
                ]),
                _vm._v(" "),
                _c("td", { staticStyle: { "text-align": "left" } }, [
                  _vm._v(_vm._s(accInfo.name))
                ]),
                _vm._v(" "),
                _c("td", { staticStyle: { "text-align": "left" } }, [
                  _vm._v(_vm._s(accInfo.catName))
                ]),
                _vm._v(" "),
                _c("td", { staticStyle: { "text-align": "left" } }, [
                  _vm._v(_vm._s(accInfo.brandName))
                ]),
                _vm._v(" "),
                _c("td", { staticStyle: { "text-align": "left" } }, [
                  _vm._v(_vm._s(accInfo.modelSpec))
                ]),
                _vm._v(" "),
                _c("td", { staticStyle: { "text-align": "left" } }, [
                  _vm._v(_vm._s(accInfo.vendorSn))
                ]),
                _vm._v(" "),
                _c("td", { staticStyle: { "text-align": "left" } }, [
                  _vm._v(_vm._s(accInfo.boundDevcName))
                ]),
                _vm._v(" "),
                _c(
                  "td",
                  { staticStyle: { "text-align": "left" } },
                  [
                    _c("el-input", {
                      attrs: { type: "textarea" },
                      model: {
                        value: accInfo.faultDesc,
                        callback: function($$v) {
                          _vm.$set(accInfo, "faultDesc", $$v)
                        },
                        expression: "accInfo.faultDesc"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("td", { attrs: { align: "left" } }, [
                  _c(
                    "a",
                    {
                      staticClass: "swb-btn-link",
                      on: {
                        click: function($event) {
                          _vm.removeAcc(accInfo)
                        }
                      }
                    },
                    [_vm._v("移除")]
                  )
                ])
              ])
            }),
            _vm._v(" "),
            _vm._m(3)
          ],
          2
        ),
        _vm._v(" "),
        _c("tfoot", { staticClass: "foot" }, [
          _c("tr", { staticClass: "row" }, [
            _c("td", { attrs: { colspan: "9" } }, [
              _c(
                "div",
                {
                  staticClass: "swb-btn-link",
                  on: {
                    click: function($event) {
                      _vm.selectAcc()
                    }
                  }
                },
                [_vm._m(4)]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [_c("label")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [_c("label")])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "head" }, [
      _c("tr", { staticClass: "row" }, [
        _c(
          "th",
          { staticStyle: { "text-align": "left" }, attrs: { width: "200" } },
          [_vm._v("服务商")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticStyle: { "text-align": "left" }, attrs: { width: "120" } },
          [_vm._v("原出库仓库")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticStyle: { "text-align": "left" }, attrs: { width: "200" } },
          [_vm._v("配件名称")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticStyle: { "text-align": "left" }, attrs: { width: "120" } },
          [_vm._v("分类")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticStyle: { "text-align": "left" }, attrs: { width: "120" } },
          [_vm._v("品牌")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticStyle: { "text-align": "left" }, attrs: { width: "180" } },
          [_vm._v("规格")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticStyle: { "text-align": "left" }, attrs: { width: "150" } },
          [_vm._v("厂商序列号")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticStyle: { "text-align": "left" }, attrs: { width: "160" } },
          [_vm._v("设备名称")]
        ),
        _vm._v(" "),
        _c(
          "th",
          { staticStyle: { "text-align": "left" }, attrs: { width: "120" } },
          [_vm._v("故障说明")]
        ),
        _vm._v(" "),
        _c("th", { attrs: { width: "80", align: "left" } }, [_vm._v("操作")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("tr", { staticClass: "row" }, [
      _c("td", { staticClass: "display-none", attrs: { colspan: "9" } }, [
        _c("div", { staticClass: "no-data" }, [
          _c("i", {
            staticClass: "icon iconfont icon-zanwushuju mr10",
            staticStyle: { "font-size": "58px", "vertical-align": "middle" }
          }),
          _vm._v(" "),
          _c("span", {}, [_vm._v("暂无数据 . . .")])
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("i", { staticClass: "icon iconfont icon-jiahao mr5" }),
      _vm._v("选择配件\n                        ")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f44e75b8", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f44e75b8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/accStock/SpecificAccRepairVoucherSave.vue
// module id = 2838
// module chunks = 0